import React, { useState } from "react";
import Images from "../Constants/Images";
import Colors from "../Constants/Color";
import ScrollAnimation from "react-animate-on-scroll";
import { useTranslation } from "react-i18next";
import SendAskAwayEmail from "../Util/SendAskAwayEmail";
import GetOnBoardEmail from "../Util/GetOnBoardEmail";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../Config/Actions/loadingActions";
import { useDispatch } from "react-redux";
import CustomBanner from "../Components/CustomBanner/CustomBanner";
import CustomDropdown from "../Components/DropDown/CustomDropdown"
const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const [boardFormData, setBoardFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const [boardErrors, setBoardErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [Success, setSuccess] = useState(false);
  const [countryCode, setCountryCode] = useState('+1');
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };
  const handlecountryCode = (newPromise) => {
    setCountryCode(newPromise)
  }
  const handleBoardChange = (e) => {
    setBoardFormData({
      ...boardFormData,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    let formErrors = {};
    let valid = true;


    if (!formData.name) {
      valid = false;
      formErrors.name = "Name is required.";
    }

    if (!formData.email) {
      valid = false;
      formErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      valid = false;
      formErrors.email = "Email is invalid.";
    }

    if (!formData.subject) {
      valid = false;
      formErrors.subject = "Subject is required.";
    }

    if (!formData.phone) {
      valid = false;
      formErrors.phone = "Phone number is required.";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      valid = false;
      formErrors.phone = "Phone number is invalid.";
    }

    if (!formData.message) {
      valid = false;
      formErrors.message = "Message is required.";
    }
    setErrors(formErrors);
    return valid;
  };

  const validateBoardForm = () => {
    let formErrors = {};
    let valid = true;

    if (!boardFormData.name) {
      valid = false;
      formErrors.name = "Name is required.";
    }

    if (!boardFormData.email) {
      valid = false;
      formErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(boardFormData.email)) {
      valid = false;
      formErrors.email = "Email is invalid.";
    }
    if (!boardFormData.phone) {
      valid = false;
      formErrors.phone = "Phone number is required.";
    } else if (!/^\d{10}$/.test(boardFormData.phone)) {
      valid = false;
      formErrors.phone = "Phone number is invalid.";
    }

    if (!boardFormData.message) {
      valid = false;
      formErrors.message = "Message is required.";
    }
    setBoardErrors(formErrors);
    return valid;
  };
  const dispatch = useDispatch();
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      dispatch(setLoadingTrue());
      try {
        await SendAskAwayEmail(formData);
        dispatch(setLoadingFalse());
        setSuccess(true);
        setFormData({
          email: "",
          message: "",
          name: "",
          phone: "",
          subject: "",
        });
        setTimeout(() => {
          setSuccess(false);
        }, 2500);
      } catch (error) {
        dispatch(setLoadingFalse());
      }
    }
  };
  const handleBoardSubmit = async (e) => {
    e.preventDefault();
    if (validateBoardForm()) {
      dispatch(setLoadingTrue());
      try {
        await GetOnBoardEmail(boardFormData);
        dispatch(setLoadingFalse());
        setSuccess(true);
        setBoardFormData({
          email: "",
          message: "",
          name: "",
          phone: "",
          subject: "",
        });
        setTimeout(() => {
          setSuccess(false);
        }, 2500);
      } catch (error) {
        dispatch(setLoadingFalse());
      }
    }
  };
  const { t } = useTranslation();
  const bannerdata = [
    {
      Name: "CONNECT WITH US",
      Bannerimg: Images.ContactBanner,
      Title: ""

    }
  ]
  const handlesubject = (lng) => {
    setFormData({
      ...formData,
      subject: lng,
    });
  };
  return (
    <div className="About_us">
      <CustomBanner bannerdata={bannerdata} />
      <div className="conatac_data bg-black  contect_from relative Ask_Away">


        <div className="container">
          <div
            className="Contact_Information items-top"
            style={{ color: Colors.black }}
          >
            <div className="Information_w flex justify-start">
              <div>
                <ScrollAnimation animateIn="bounceInLeft">
                  <div className="font-48 cinzel  text-white capitalize">
                    {t("Contact Us")}
                  </div>
                </ScrollAnimation>
                <ScrollAnimation animateIn="bounceInLeft">
                  <p
                    className="font-20 Optima text-white "
                    style={{ marginTop: "17px" }}
                  >
                    {t("We are here to help you feel at home. Get in touch")} <br /><span className='showbr'></span>
                    {t("with us if you have any inquiries about our stays,")} <br /><span className='showbr'></span>
                    {t("bookings, services, and more.")}
                  </p>
                </ScrollAnimation>
                <ScrollAnimation animateIn="bounceInLeft">
                  <div className="contact_Icons">
                    <div className=" Optima font-20 text-white">
                      {t("24/7 Support")}
                    </div>
                  </div>
                </ScrollAnimation>
                <ScrollAnimation animateIn="bounceInLeft">
                  <div className="contact_Icons">
                    <div className=" Optima  font-20 text-white">
                      {t("Customer Service | KŌZĒ")}
                    </div>
                  </div>
                </ScrollAnimation>
                <ScrollAnimation animateIn="bounceInLeft">
                  <div className="contact_Icons">
                    <div className="  Optima font-20 text-white ">
                      {t("customerservice@kozechalets.ca")}
                    </div>
                  </div>
                </ScrollAnimation>
                <ScrollAnimation animateIn="bounceInLeft">
                  <div className="contact_Icons text-white">
                    <div className=" Optima font-20">
                      {t("+1 (514) 447-7149")}
                    </div>
                  </div>
                </ScrollAnimation>
              </div>
            </div>
            <div className="Information_t">
              <div
                className="font-48 cinzel  text-white relative capitalize"
                style={{ marginBottom: "-10px" }}
              >
                {t("Ask Away!")}
              </div>
              <form onSubmit={handleSubmit}>
                <div  className="Question_grid Optima ">
                  <div >
                    <ScrollAnimation animateIn="none">
                      <input
                        type="text"
                        name="name"
                        style={{ border: "0.5px solid #111111", color: "white" }}
                        placeholder={t("Name")}
                        value={formData.name}
                        onChange={handleChange}

                      />
                    </ScrollAnimation>
                    {errors.name && <span>{t(errors.name)}</span>}
                  </div>
                  <div>
                    <ScrollAnimation animateIn="none">
                      <input
                        type="email"
                        name="email"
                        style={{ border: "0.5px solid #111111", color: "white" }}
                        placeholder={t("Email")}
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </ScrollAnimation>
                    {errors.email && <span>{t(errors.email)}</span>}
                  </div>
                </div>
                <div className="Question_grid">
                  <div style={{ width: "100%" }}>
                    <div className="subject_data">
                      <CustomDropdown
                        dropDownLabel={formData.subject === "" ? `${t("Subject")}` : formData.subject}
                        items={["Reservation", "Looking for a Property Management Company", "General Inquiry", "Other"]}
                        onSelect={handlesubject}
                      />
                    </div>
                    {errors.subject && <span>{t(errors.subject)}</span>}
                  </div>
                  <div>
                    <div className="countryCode">
                      <div className="subject_data">
                        <CustomDropdown
                          dropDownLabel={countryCode}
                          items={["+1", "+44", "+91", "+61", "+33",]}
                          onSelect={handlecountryCode}
                        />
                      </div>
                      <input
                        type="number"
                        name="phone"
                        className="Optima"
                        style={{ border: "0.5px solid #111111", color: "white", zIndex: "999" }}
                        placeholder={t("Phone Number")}
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.phone && <span>{t(errors.phone)}</span>}
                  </div>
                </div>
                <div>
                  <ScrollAnimation animateIn="none">
                    <textarea
                      name="message"

                      value={formData.message}
                      className="message_black_to_white Optima"
                      placeholder={t("Message")}
                      style={{ border: "0.5px solid #111111", color: "white", paddingTop: "35px!important" }}
                      onChange={handleChange}
                    ></textarea>
                  </ScrollAnimation>
                  {errors.message && <span>{t(errors.message)}</span>}
                </div>
                <ScrollAnimation animateIn="none">
                  <div className="Question_grid ">
                    <button className=" white_class w-fit Optima" style={{ background: "#E0C9AA", paddingLeft: "60px", paddingRight: "60px", fontWeight: "700", fontFamily: "Optima" }} type="submit ">
                      {t("Send")}
                    </button>
                  </div>
                </ScrollAnimation>
              </form>
            </div>
          </div>
        </div>
        {Success && (
          <div className="Success">
            <div className="Success_center">
              <div>Your request has been successfully submitted</div>
              <div
                onClick={() => setSuccess(false)}
                style={{ padding: "4px" }}
                className="custom-btn btn-14"
              >
                Ok
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="conatac_data bg-[#E0C9AA]  contect_from">
        <div className="container">
          <div
            className="Contact_Information items-top"
            style={{ color: Colors.black }}
          >
            <div  className="Information_t ">
              <div
                className="font-48 cinzel capitalize"
                style={{ marginBottom: "-10px" }}
              >
                {t("Get On-Board!")}
              </div>
              <form onSubmit={handleBoardSubmit}>
                <div  className="Question_grid Optima">
                  <div >
                    <ScrollAnimation animateIn="none">
                      <input
                        type="text"
                        className="Optima"
                        name="name"
                        style={{ border: "0.5px solid #111111" }}
                        placeholder={t("Name")}
                        value={boardFormData.name}
                        onChange={handleBoardChange}
                      />
                    </ScrollAnimation>
                    {boardErrors.name && <span>{t(boardErrors.name)}</span>}
                  </div>
                  <div>
                    <ScrollAnimation animateIn="none">
                      <input
                        type="email"
                        className="Optima"
                        name="email"
                        style={{ border: "0.5px solid #111111" }}
                        placeholder={t("Email")}
                        value={boardFormData.email}
                        onChange={handleBoardChange}
                      />
                    </ScrollAnimation>
                    {boardErrors.email && <span>{t(boardErrors.email)}</span>}
                  </div>
                </div>
                <div className="Question_grid">
                  <div>
                    <ScrollAnimation animateIn="none">
                      <input
                        type="text"
                        className="Optima"
                        name="subject"
                        style={{ border: "0.5px solid #111111" }}
                        placeholder={t("Subject")}
                        value={boardFormData.subject}
                        onChange={handleBoardChange}
                      />
                    </ScrollAnimation>
                    {boardErrors.subject && (
                      <span className=" visible hidden">{t(boardErrors.subject)}</span>
                    )}
                  </div>
                  <div>
                      <div className="countryCode newBoardcode">
                        <div className="subject_data">
                          <CustomDropdown
                            dropDownLabel={countryCode}
                            items={["+1", "+44", "+91", "+61", "+33",]}
                            onSelect={handlecountryCode}
                          />
                        </div>
                        <input
                        type="number"
                        className="Optima"
                        name="phone"
                        style={{ border: "0.5px solid #111111" }}
                        placeholder={t("Phone Number")}
                        value={boardFormData.phone}
                        onChange={handleBoardChange}
                      />
                      </div>
                    {boardErrors.phone && <span>{t(boardErrors.phone)}</span>}
                  </div>
                </div>
                <div>
                  <ScrollAnimation animateIn="none">
                    <textarea
                      name="message"
                      className="Optima"
                      value={boardFormData.message}
                      placeholder={t("Message")}
                      style={{ border: "0.5px solid #111111" }}
                      onChange={handleBoardChange}
                    ></textarea>
                  </ScrollAnimation>
                  {boardErrors.message && <span>{t(boardErrors.message)}</span>}
                </div>
                <ScrollAnimation animateIn="none">
                  <div className="Question_grid ">
                    <button className="orange_class w-fit" style={{ paddingLeft: "60px", paddingRight: "60px", fontWeight: "700", fontFamily: "Optima" }} type="submit ">
                      {t("Send")}
                    </button>
                  </div>
                </ScrollAnimation>
              </form>
            </div>
            <div
              style={{ display: "flex" }}
              className="Information_w mt-12 max-[991px]:mt-0 justify-center max-[991px]:justify-start"
            >
              <div className="">
                <ScrollAnimation animateIn="bounceInRight">
                  <div className="font-48 cinzel capitalize ">{t("Own Rentals?")}</div>
                </ScrollAnimation>
                <ScrollAnimation animateIn="bounceInRight">
                  <p className="font-20 Optima" style={{ marginTop: "10px" }}>
                    {t("Fill out this form if you are looking to manage")}
                    <br /><span className='showbr ' style={{ display: "none" }}></span> {t("your property. Our team will get in touch with")}
                    <br /><span className='showbr' style={{ display: "none" }}></span>
                    {t(" you shortly.")}
                  </p>
                </ScrollAnimation>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
export default ContactUs;
